<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <el-row v-if="!loading">
      <el-col :span="16">
        <table class="totalsTable hiaTable">
          <tbody>
            <tr>
              <td class="findings-cell">
                <span class="findings-label">Records Reviewed With EM Codes</span>
                <span class="findings-value">{{ recordTotals.totalRecords }}</span>
              </td>
              <td class="findings-cell">
                <span class="findings-label">Records Without EM Findings</span>
                <div class="findings-value-row">
                  <span class="findings-value-text">{{ recordTotals.recordsWithoutFindings }}</span>
                  <span class="tag-success">{{
                    calculatePercentageForCards(recordTotals.totalRecords, recordTotals.recordsWithoutFindings) }}</span>
                </div>
              </td>
              <td class="findings-cell">
                <span class="findings-label">Records With EM Findings</span>
                <div class="findings-value-row">
                  <span class="findings-value-text">{{ recordTotals.recordsWithFindings }}</span>
                  <span class="tag-danger">{{
                    calculatePercentageForCards(recordTotals.totalRecords, recordTotals.recordsWithFindings) }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </el-col>
    </el-row>

    <el-row v-for="codeType in codeTypesAndData" style="margin-top: 30px; margin-bottom:20px;" :key="codeType.codeDesc">
      <h3>{{codeType.codeDesc}}</h3>

      <el-col :span="16">
        <table class="hiaTable" style="margin-top: 20px;">
          <thead>
            <tr>
              <th> Description </th>
              <th> Frequency </th>
              <th> % of {{codeType.codeDesc}} </th>
              <th v-if="tenantSetup.showRVUsInPrintableReports"> RVU Impact </th>
            </tr>
          </thead>
          <tr v-for="item in codeType.data" :key="item.description">
            <td class="textAlignLeft"> {{item.description}} </td>
            <td> {{item.numberOfCodes}} </td>
            <td> {{formatPercentage(item.percentOfTotal)}} </td>
            <td v-if="tenantSetup.showRVUsInPrintableReports" :class="`${item.rvuDiff < 0 ? 'negative' : ''}`"> {{item.rvuDiff}}</td>
          </tr>
          <tr class="strong emphasis">
            <td class="textAlignLeft">Total</td>
            <td>{{getSummaries(codeType.data)[1]}}</td>
            <td>N/A</td>
            <td v-if="tenantSetup.showRVUsInPrintableReports">{{getSummaries(codeType.data)[3]}}</td>
          </tr>
        </table>

      </el-col>
      <el-col :span="8">
        <pieChart :data="codeType.data" :nameValue="'description'" :yValue="'percentOfTotal'"></pieChart>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'
  import pieChart from '../highcharts/pieChart'

  export default {
    name: 'PRO_FindingSummaryEMPrintable',
    mixins: [hiaFilters, money, dashboardHelper],
    props: ['proRecordIds', 'codeTypes'],
    components: {
      pieChart
    },
    data: function () {
      return {
        tableData: [],
        recordTotals: {},
        filterCriteria: '',
        loading: false,
        summaryRow: {},
        detailsHeader: ''
      }
    },
    methods: {
      ...mapActions('managedLists/tenantSetup/', ['GET_TENANT_SETUP']),
      async getData() {
        const payload = {
          proRecordIds: this.proRecordIds,
          codeTypes: this.codeTypes,
          includeAccts: true,
          statType: 'test'
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/dashboard/proEMFindingSummary`, payload)
          this.tableData = response.data.largeStat.data
          this.recordTotals = response.data.recordTotals
        } catch (err) {
          this.tableData = []
        } finally {
          this.$nextTick(() => {
            // this.$refs.dxTable.doLayout()
            this.loading = false
          })
        }
      },
      getCodeTypes() {
        const codeTypes = [...new Set(this.tableData.map(x => x.codeDesc))]
        return codeTypes
      },
      getSummaries(data) {
        const param = {
          columns: [
            { property: 'description' },
            { property: 'numberOfCodes' },
            { property: 'percentOfChanges' },
            { property: 'rvuDiff' }
          ],
          data: data
        }
        return this.getSummary(param)
      },
      cellClasses({ row, column, rowIndex, columnIndex }) {
        if (column.property === 'code' || column.property === 'description' || column.property === 'codeDesc') {
          return 'textAlignLeft'
        }
        if (column.property === 'details') {
          return 'textAlignCenter'
        }
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      ...mapState('managedLists/tenantSetup/', ['tenantSetup']),
      codeTypesAndData() {
        const codeTypeList = [...new Set(this.tableData.map(x => x.codeDesc))]
        const codeTypesAndData = []
        for (let i = 0; i < codeTypeList.length; i++) {
          codeTypesAndData.push({
            codeDesc: codeTypeList[i],
            data: this.tableData.filter(x => x.codeDesc === codeTypeList[i])
          })
        }

        return codeTypesAndData
      }
    },
    mounted: async function () {
      await this.GET_TENANT_SETUP()
      await this.getData()
    },
    watch: {
      proRecordIds: async function () {
        await this.getData()
      },
      codeTypes: async function () {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
  .totalsTable {
    border-spacing: 0px;
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }

  .totalsTable td {
    padding: 13px;
  }
</style>